import { render, staticRenderFns } from "./QuestionDetails.vue?vue&type=template&id=554e2934&scoped=true&"
import script from "./QuestionDetails.vue?vue&type=script&lang=js&"
export * from "./QuestionDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDetails.vue?vue&type=style&index=0&id=554e2934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e2934",
  null
  
)

export default component.exports